// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"761":"8bd3bceb","771":"58343530"}[chunkId] + ".chunk.css";
};